export default class Client {
  id: number = 0;
  idclient: string = '';
  dossier: string = '';
  nom: string = '';
  prenom: string = '';
  telf: string = '';
  telm: string = '';
  email: string = '';
  adresse1: string = '';
  adresse2: string = '';
  codepostal: string = '';
  ville: string = '';
  emailagent: string = '';
  telagent: string = '';
  partenaire: string = '';
  campagne: string = '';
  dlu: string = '';
  created_at: string = '';
  updated_at: string = '';
}
